import React, { FormEvent, FunctionComponent, useCallback } from 'react';

import { AddButton, CardList, SubmitButton } from 'components';
import { FormGroup } from 'components/chroma';

import { YesNoAnswer } from 'scenes/common/types';
import { getApiData } from 'scenes/common/helpers/apiData';

import { Driver, MotorFullPageProps } from 'scenes/motor/types';
import analytics from 'scenes/motor/analytics';
import { DriverDetailsCard } from './DriverDetailsCard';

const maxAdditionalDriverCount = 10;

export const AdditionalDriversList: FunctionComponent<
  Pick<
    MotorFullPageProps,
    | 'funnelState'
    | 'referenceData'
    | 'onEditDriver'
    | 'onRemoveDriver'
    | 'onNext'
  > & { additionalDrivers: Driver[] }
> = ({
  funnelState,
  referenceData,
  additionalDrivers,
  onEditDriver,
  onRemoveDriver,
  onNext,
}) => {
  const onSubmit = useCallback(
    (event: FormEvent) => {
      analytics().driverAdded(funnelState, getApiData(referenceData));
      onNext({ addDriver: YesNoAnswer.No });
      event.preventDefault();
    },
    [funnelState, onNext, referenceData]
  );

  const addAdditionalDriver = useCallback(() => {
    analytics().addDriver(funnelState, getApiData(referenceData));
    onNext({ addDriver: YesNoAnswer.Yes });
  }, [funnelState, onNext, referenceData]);

  return (
    <form onSubmit={onSubmit}>
      <FormGroup label="You added these following additional drivers">
        <CardList marginBottom="1rem" role="list">
          {additionalDrivers.map((driver, index) => (
            <DriverDetailsCard
              key={`${driver.firstName}${driver.lastName}`}
              onEditDriver={onEditDriver}
              onRemoveDriver={onRemoveDriver}
              driver={driver}
              index={index}
              flowType={funnelState.flow}
            />
          ))}
        </CardList>
        {additionalDrivers.length < maxAdditionalDriverCount ? (
          <AddButton onClick={addAdditionalDriver}>
            Add an additional driver
          </AddButton>
        ) : (
          <></>
        )}
      </FormGroup>
      <SubmitButton enabled>Next</SubmitButton>
    </form>
  );
};

export default AdditionalDriversList;
